import React from "react";
import "./HeadlineSlider.css";

const HeadlineSlider = () => {
  // const headlines = [
  //   "Register 9th Annual Pediatric Urology Free Camp – Nov 16-17, 2025 | Shri Markandey Solapur Sahakari Rugnalaya | Register Now in Events!",
  // ];
const headlines = [
  `Site is under construction. Stay tuned for updates! \u00A0\u00A0\u00A0\u00A0 Site is under construction. Stay tuned for updates!`
];


  return (
    <div className="headline-slider">
      <div className="headline-container">
        {headlines.map((headline, index) => (
          <h2 className="headline" key={index}>
            {headline}
          </h2>
        ))}
        {/* Duplicate headlines for smooth infinite scroll */}
        {headlines.map((headline, index) => (
          <h2 className="headline" key={`dup-${index}`}>
            {headline}
          </h2>
        ))}
      </div>
    </div>
  );
};

export default HeadlineSlider;
